/** Shapes returned by the endpoints in `src/api/inventory.js`. */

export interface ProductRow {
	uuid: string;
	id?: number | string;
	item_id?: string;
	name?: string;
	sku?: string;
	image?: string | null;
	description?: string;
	available_qty?: number;
	price?: number | string;
	cost_price?: number | string;
	first_name?: string;
	last_name?: string;
	entity_name?: string;
	is_archived?: boolean;
}

/** Prototype §2.3: status is derived from quantity, with a hardcoded low-stock threshold of 10. */
export type StockStatus = "instock" | "low" | "out";

export const LOW_STOCK_THRESHOLD = 10;

export const stockStatusOf = (qty?: number): StockStatus => {
	const quantity = qty ?? 0;
	if (quantity > LOW_STOCK_THRESHOLD) return "instock";
	if (quantity > 0) return "low";
	return "out";
};

export interface StockRequestRow {
	uuid: string;
	product_name?: string;
	quantity?: number;
	approved_quantity?: number;
	status?: string;
	needed_by?: string;
	created_at?: string;
	requesting_entity?: string;
	receiving_entity?: string;
}

export interface Entity {
	uuid: string;
	/** Numeric key. `store_or_warehouse_id` on products is this, not the uuid. */
	id?: number | string;
	name: string;
}

/** One line on `GET /inventories/requests/:uuid`. */
export interface StockRequestItem {
	product_id?: string | number;
	name?: string;
	sku?: string;
	requested_quantity?: number;
	approved_quantity?: number;
}

/** `GET /inventories/requests/:uuid` → `data`. */
export interface StockRequestDetail {
	uuid?: string;
	from_name?: string;
	to_name?: string;
	status?: string;
	created_at?: string;
	items?: StockRequestItem[];
}
